<template lang="pug">
el-dialog(v-dialogDrag title="关联表" :visible.sync="dataDialog" width="600px" :before-close="handleClose")
  .operList
    el-input(v-model='filterText' placeholder="输入关键字进行过滤",size="small" @change="changeData" )
    el-table(:data="tableData",border,height='300px',@selection-change="handleSelectionChange")
      el-table-column( type="selection",width="55" align="center")
      el-table-column(prop="tableName" label="表名" sortable)
      el-table-column(prop="tableDesc" label="描述")
  span(slot="footer")
    el-button(@click="handleClose" size="small") 取 消
    el-button(type="primary" @click="onSubmit" size="small") 导 入
</template>

<script>
import metadataService from "@/CommonDP/service/metadata-service.js";
export default {
  data () {
    return {
      dataDialog: false,
      filterText: '',
      tableData: [],
      initData: [],
      multipleSelection: [],
      groupId: ''
    };
  },
  mounted () {

  },
  methods: {
    // 关联
    async correlation(data) {
      this.filterText = '';
      this.groupId = data.groupId;
      const res = await metadataService.queryDynMetaViewTableList(this.groupId);
      this.tableData = res.data;
      this.initData = this.tableData;
      this.dataDialog = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    changeData(val) {
      if (val) {
        this.tableData = this.initData.filter(e => e.tableDesc?.includes(val) || e.tableName?.includes(val));
      } else {
        this.tableData = this.initData;
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.tableName.indexOf(value) !== -1;
    },
    handleClose() {
      this.dataDialog = false;
    },
    async onSubmit() {
      if (this.multipleSelection.length === 0) {
        this.$warn("请选择需要导入的表");
        return;
      }
      await this.$confirm(`确认导入选中的这${this.multipleSelection.length}张表吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async() => {
        const viewTableList = this.multipleSelection.map(e => {
          return {
            tableName: e.tableName,
            tableDesc: e.tableDesc
          };
        });
        const params = {
          groupId: this.groupId,
          viewTableList
        };
        await metadataService.exportViewTable(params);
        this.$emit('initTree');
        this.$success("操作成功");
        this.dataDialog = false;
      });
    },
    // 保存表单
    saveFormData() {

    }
  }
};
</script>

<style lang="scss" scoped>
.operList {
  .el-table {
    margin-top: 5px;
  }
}
</style>

